import qs from 'query-string';

export function currentQueryParams(location) {
  return qs.parse(location.search);
}

export function pathForQueryParams(location, queryParams) {
  let path = location.pathname;
  let params = {
    ...qs.parse(location.search),
    ...queryParams
  };

  Object.keys(params).forEach(key => {
    if (!params[key]) delete params[key];
  });

  const querystring = qs.stringify(params);
  if (querystring) path += `?${querystring}`;

  return path;
}
